import {
  analyticsSocialSharedEventAfterSearch,
  analyticsSocialSharedEventBeforeSearch,
  analyticsAddToFavouriteEventAfterSearch,
  analyticsAddToFavouriteEventBeforeSearch,
  analyticsAddToCartEventAfterSearch,
  analyticsAddToCartEventBeforeSearch,
} from "@/services/algolia/analytics";
import { useAppSelector } from "./reactUseCustomHooks";
import { useCallback } from "react";
import { algoliaConfig } from "@/services/algolia/config";
import { GlobalSearchSectionsType } from "../types/algolia";

export type InteractionEvent = {
  id: string;
  type: GlobalSearchSectionsType;
  eventType: "share" | "addToFavourite" | "addToList";
  customPayload?: { afterSearch: unknown; beforeSearch: unknown };
};

const useInteractionEventAnalytics = () => {
  const { pathQueue, search: globalSearch } = useAppSelector(
    (state) => state.algoliaSlice
  );
  const { uid } = useAppSelector((state) => state.gigyaslice);

  const event: Record<
    InteractionEvent["eventType"],
    { afterSearch: Function; beforeSearch: Function }
  > = {
    share: {
      afterSearch: analyticsSocialSharedEventAfterSearch,
      beforeSearch: analyticsSocialSharedEventBeforeSearch,
    },
    addToFavourite: {
      afterSearch: analyticsAddToFavouriteEventAfterSearch,
      beforeSearch: analyticsAddToFavouriteEventBeforeSearch,
    },
    addToList: {
      afterSearch: analyticsAddToCartEventAfterSearch,
      beforeSearch: analyticsAddToCartEventBeforeSearch,
    }
  };

  const handleInteractionEvent = useCallback(
    ({ id, type, eventType, customPayload }: InteractionEvent) => {
      const pathQLen = pathQueue.length;
      const redirectedFromSearch =
        (pathQLen >= 2 && pathQueue[pathQLen - 2] === "/search") ||
        Boolean(globalSearch?.queryValue?.length);
      const genericPayload = {
        kind: type,
        index: algoliaConfig.indexNames[type],
        objectIDs: [id],
        userToken: uid || undefined,
      };
      if (redirectedFromSearch && globalSearch.queryID?.[type]?.length) {
        const payload = customPayload
          ? customPayload.afterSearch
          : { ...genericPayload, queryID: globalSearch.queryID[type] };
        event[eventType].afterSearch(payload);
      } else {
        const payload = customPayload
          ? customPayload.beforeSearch
          : genericPayload;
        event[eventType].beforeSearch(payload);
      }
    },
    [pathQueue, globalSearch]
  );

  return handleInteractionEvent;
};

export default useInteractionEventAnalytics;
